import type { Contact } from '../types'

export const getLinkedInId = ({
	linkedin_entity_id: linkedInId,
	linkedin_public_identifier: linkedinPublicId
}: Pick<Contact, 'linkedin_entity_id' | 'linkedin_public_identifier'>) =>
	linkedInId ?? linkedinPublicId

export const getLinkedInLinkProps = ({
	actions,
	...contact
}: Pick<
	Contact,
	'actions' | 'linkedin_entity_id' | 'linkedin_public_identifier'
>) => ({
	...actions.open_linkedin_profile,
	id: getLinkedInId(contact)
})
